import React, { PropTypes } from 'react';
import { withRouter } from 'react-router';
import TabbedNavigation from 'common/components/tabbed_navigation';
import { v4 } from 'node-uuid';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';

const PRESS_ARR = [{
  image: 'https://s3.amazonaws.com/crowdspring3-assets/marketing/news/asi-logo-news.jpg',
  publication: 'Advertising Speciality Institute',
  date: 'Aug 17 2017',
  link: 'https://www.asicentral.com/news/newsletters/promogram/august-2017/alibaba-reports-strong-quarterly-sales/',
  title: 'Alibaba Reports Strong Quarterly Sales',
  description: 'The company is also targeting new merchants in Russia and the U.S., including a partnership between online shopping platform AliExpress and Chicago-based design firm crowdspring.',
  type: 'news',
}];

const TABS = {
  links: [{
    url: '/press/',
    name: 'All News',
    matchExact: true,
  }, {
    url: '/press/releases/',
    name: 'Releases',
    matchExact: true,
  }, {
    url: '/press/in-the-news/',
    name: 'In The News',
    matchExact: true,
  }],
};

const Base = ({ children, router }) => (
  <div className="l-content press" id="content">
    <div className="row">
      <div className="small-16 medium-12 columns">
        <h2>Latest News</h2>
        <TabbedNavigation tabs={TABS} router={router} />
        {children}
      </div>
      <aside className="small-16 small-pull-16 medium-4 columns sidebar">
        <section>
          <h3>Media Inquiries</h3>
          <p><a href="mailto:pr@crowdspring.com">pr@crowdspring.com</a></p>
        </section>
        <section>
          <h3>Downloads</h3>
          <p>Coming Soon</p>
        </section>
      </aside>
    </div>
  </div>
);

Base.propTypes = {
  children: PropTypes.any,
  router: PropTypes.object.isRequired,
};

const PressPiece = ({
  image, title, description, publication, date, link
}) => (
  <div className="row">
    <div className="hide-for-small-only medium-2 columns">
      {image && <img src={image} alt={title} />}
    </div>
    <div className="small-16 medium-14 columns">
      <h3><a href={link} target='_blank'>{title}</a></h3>
      <p>{publication}, {date}</p>
      <p>{description}</p>
    </div>
  </div>
);

PressPiece.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  publication: PropTypes.string,
  date: PropTypes.string,
  link: PropTypes.string,
};

const Wrapper = withRouter(Base);

const All = () => (
  <div className="row">
    <Meta
      title="News"
      meta={[
        { name: 'robots', content: 'index,follow' },
        { name: 'description', content: 'News, press releases about crowdspring as well as resources for the media.' },
        { name: 'keywords', content: 'crowdsource, contests, design contests, writing contests, copywriting, design, crowdsourcing' }
      ]}
      link={[{ rel: 'canonical', href: getCanonicalURL('/press/') }]}
    />
    <div className="small-16 columns">
      {PRESS_ARR.map(piece => (<PressPiece key={v4()} {...piece} />))}
    </div>
  </div>
);

const Releases = () => (
  <div className="row">
    <Meta
      title="Press releases"
      meta={[
        { name: 'robots', content: 'noindex,follow' },
        { name: 'description', content: 'News, press releases about crowdspring as well as resources for the media.' },
        { name: 'keywords', content: 'crowdsource, contests, design contests, writing contests, copywriting, design, crowdsourcing' }
      ]}
      link={[{ rel: 'canonical', href: getCanonicalURL('/press/releases/') }]}
    />
    <div className="small-16 columns">
      {PRESS_ARR.filter(({ type }) => (type === 'release')).map(piece => (
        <PressPiece key={v4()} {...piece} />
      ))}
    </div>
  </div>
);

const News = () => (
  <div className="row">
    <Meta
      title="In the News"
      meta={[
        { name: 'robots', content: 'noindex,follow' },
        { name: 'description', content: 'News, press releases about crowdspring as well as resources for the media.' },
        { name: 'keywords', content: 'crowdsource, contests, design contests, writing contests, copywriting, design, crowdsourcing' }
      ]}
      link={[{ rel: 'canonical', href: getCanonicalURL('/press/in-the-news/') }]}
    />
    <div className="small-16 columns">
      {PRESS_ARR.filter(({ type }) => (type === 'news')).map(piece => (
        <PressPiece key={v4()} {...piece} />
      ))}
    </div>
  </div>
);

const Press = {
  Wrapper, All, Releases, News
};
export default Press;



// WEBPACK FOOTER //
// ./marketing/about/press.jsx